import { useSessionStorage } from '@mantine/hooks';

// A session-storage hook to store the value of 'fbl-apply-coupon' in session storage
type Applied = 'true' | 'false';

function useFBLSpecialCoupon() {
  const [value, setValue, removeValue] = useSessionStorage<Applied>({
    key: 'fbl-coupon-applied',
    defaultValue: 'false',
  });

  return { value, setValue, removeValue };
}

export { useFBLSpecialCoupon };
